export const PhoneMockup = () => {
  return (
    <div>

      {/* Large Screens (1200px and above) */}
      <div className="hidden min-[1200px]:block">
        <div className="w-[80%] min-[1200px]:w-[700px] mx-auto animate-floatSlow">
          <img
            src="/images/Webp/2pjcbw3k14gd59z05nimgbmxjsa-3.webp"
            className="w-full object-contain drop-shadow-[0px_60px_120px_rgba(0,0,0,0.35)]"
          />
        </div>
      </div>

      {/* Medium Screens (md to 1199px) */}
      <div className="hidden md:block min-[1200px]:hidden">
        <div className="w-[620px] max-[1120px]:ml-0 ml-12 min-[1200px]:w-[100%] mx-auto">
          <img
            src="/images/Webp/2pjcbw3k14gd59z05nimgbmxjsa-3.webp"
            className="w-full object-contain drop-shadow-[0px_40px_80px_rgba(0,0,0,0.25)]"
          />
        </div>
      </div>

      {/* Small Screens (below md) */}
      <div className="block md:hidden">
        <div className="w-[320px] max-[400px]:w-[100%] mx-auto">
          <img
            src="/images/Webp/Hero-Mobile2.webp"
            className="w-full object-contain"
          />
        </div>
      </div>

    </div>
  );
};